module.exports = __webpack_public_path__ + "static/media/luminary-on.ba567089.png";